/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  FeeBasesStatsData
} from '../../model/feeBasesStatsData'
import type {
  FeeBasisChangeByUseData
} from '../../model/feeBasisChangeByUseData'
import type {
  FeeChargeEventBasisBreakdownBySecurityOwnershipRetrieveParams
} from '../../model/feeChargeEventBasisBreakdownBySecurityOwnershipRetrieveParams'
import type {
  FeeChargeEventBasisBreakdownByUseRetrieveParams
} from '../../model/feeChargeEventBasisBreakdownByUseRetrieveParams'
import type {
  FeeChargeEventBasisChangeByUseRetrieveParams
} from '../../model/feeChargeEventBasisChangeByUseRetrieveParams'
import type {
  FeeChargeEventComparison
} from '../../model/feeChargeEventComparison'
import type {
  FeeChargeEventComparisonTableDataRetrieveParams
} from '../../model/feeChargeEventComparisonTableDataRetrieveParams'
import type {
  FeeChargeEventCreateDataRequest
} from '../../model/feeChargeEventCreateDataRequest'
import type {
  FeeChargeEventData
} from '../../model/feeChargeEventData'
import type {
  FeeChargeEventListParams
} from '../../model/feeChargeEventListParams'
import type {
  FeeChargeEventPageData
} from '../../model/feeChargeEventPageData'
import type {
  FeeChargeEventPeriodBreakdownTableDataRetrieveParams
} from '../../model/feeChargeEventPeriodBreakdownTableDataRetrieveParams'
import type {
  FeeChargeEventStatsAPIData
} from '../../model/feeChargeEventStatsAPIData'
import type {
  FeeOffsetApplicationFormReadData
} from '../../model/feeOffsetApplicationFormReadData'
import type {
  FeeOffsetApplicationReadDataList
} from '../../model/feeOffsetApplicationReadDataList'
import type {
  FeeOffsetApplicationsFormUpsertDataRequest
} from '../../model/feeOffsetApplicationsFormUpsertDataRequest'
import type {
  FeeOffsetApplicationsListParams
} from '../../model/feeOffsetApplicationsListParams'
import type {
  FeeOffsetApplicationsUpsertParams
} from '../../model/feeOffsetApplicationsUpsertParams'
import type {
  FeeOffsetTableDataForFeeChargeEventRetrieveParams
} from '../../model/feeOffsetTableDataForFeeChargeEventRetrieveParams'
import type {
  FeePeriodHistoricalTrueUpBreakdownRetrieveParams
} from '../../model/feePeriodHistoricalTrueUpBreakdownRetrieveParams'
import type {
  FeePeriodOffsetsTrueUpBreakdownRetrieveParams
} from '../../model/feePeriodOffsetsTrueUpBreakdownRetrieveParams'
import type {
  FeePeriodTrueUpBreakdownRetrieveParams
} from '../../model/feePeriodTrueUpBreakdownRetrieveParams'
import type {
  FeeTrueUpHistoricalPreviewStatsRetrieveParams
} from '../../model/feeTrueUpHistoricalPreviewStatsRetrieveParams'
import type {
  FeeTrueUpSummaryTablesData
} from '../../model/feeTrueUpSummaryTablesData'
import type {
  FundFamilyEventData
} from '../../model/fundFamilyEventData'
import type {
  GenericSelectDataList
} from '../../model/genericSelectDataList'
import type {
  GenericTableData
} from '../../model/genericTableData'
import type {
  PreviousQuarterFeeTrueUpHistoricalStatsAPIData
} from '../../model/previousQuarterFeeTrueUpHistoricalStatsAPIData'
import type {
  TableDataGroupedByEntity
} from '../../model/tableDataGroupedByEntity'
import type {
  TransactionCodeConfigDataList
} from '../../model/transactionCodeConfigDataList'
import { axiosRequest } from '../../../shared/api/Api';


      
type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];



      import { appQueryClient } from "app/AppQueryClient";
      import { LoaderFunction, Params } from "@remix-run/router";
      import { isLoggedIn } from "axios-jwt";

      const authedLoader = (loader: LoaderFunction): LoaderFunction =>
        async (args) => {
          const result = await isLoggedIn();
          if (result) {
            return loader(args);
          }
          return null;
        };
    /**
 * Get a list of FeeChargeEvents
 */
export const feeChargeEventList = (
    fundFamilyId: string,
    params?: FeeChargeEventListParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<TableDataGroupedByEntity>(
      {url: `/fund-family/${fundFamilyId}/fee-charge-event/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getFeeChargeEventListQueryKey = (fundFamilyId: string,
    params?: FeeChargeEventListParams,) => {
    return [`/fund-family/${fundFamilyId}/fee-charge-event/`, ...(params ? [params]: [])] as const;
    }

    
export const getFeeChargeEventListQueryOptions = <TData = Awaited<ReturnType<typeof feeChargeEventList>>, TError = unknown>(fundFamilyId: string,
    params?: FeeChargeEventListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feeChargeEventList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeeChargeEventListQueryKey(fundFamilyId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feeChargeEventList>>> = ({ signal }) => feeChargeEventList(fundFamilyId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof feeChargeEventList>>, TError, TData> & { queryKey: QueryKey }
}

export type FeeChargeEventListQueryResult = NonNullable<Awaited<ReturnType<typeof feeChargeEventList>>>
export type FeeChargeEventListQueryError = unknown

export const useFeeChargeEventList = <TData = Awaited<ReturnType<typeof feeChargeEventList>>, TError = unknown>(
 fundFamilyId: string,
    params?: FeeChargeEventListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feeChargeEventList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeeChargeEventListQueryOptions(fundFamilyId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFeeChargeEventListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof feeChargeEventList>>, TError = unknown>(fundFamilyId: string,
    params?: FeeChargeEventListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeChargeEventList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeeChargeEventListQueryKey(fundFamilyId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feeChargeEventList>>> = ({ signal }) => feeChargeEventList(fundFamilyId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeChargeEventList>>, TError, TData> & { queryKey: QueryKey }
}

export type FeeChargeEventListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof feeChargeEventList>>>
export type FeeChargeEventListSuspenseQueryError = unknown

export const useFeeChargeEventListSuspense = <TData = Awaited<ReturnType<typeof feeChargeEventList>>, TError = unknown>(
 fundFamilyId: string,
    params?: FeeChargeEventListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeChargeEventList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeeChargeEventListSuspenseQueryOptions(fundFamilyId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getFeeChargeEventListLoader = (queryParamsOrFn?: (FeeChargeEventListParams | ((params: Params) => FeeChargeEventListParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId) {
            return appQueryClient.prefetchQuery({
              queryKey: getFeeChargeEventListQueryKey(fundFamilyId, queryParams),
              queryFn: () => feeChargeEventList(fundFamilyId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Create a new FeeChargeEvent
 */
export const feeChargeEventCreate = (
    fundFamilyId: string,
    feeChargeEventCreateDataRequest: FeeChargeEventCreateDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<FeeChargeEventData>(
      {url: `/fund-family/${fundFamilyId}/fee-charge-event/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: feeChargeEventCreateDataRequest
    },
      options);
    }
  


export const getFeeChargeEventCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof feeChargeEventCreate>>, TError,{fundFamilyId: string;data: FeeChargeEventCreateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof feeChargeEventCreate>>, TError,{fundFamilyId: string;data: FeeChargeEventCreateDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof feeChargeEventCreate>>, {fundFamilyId: string;data: FeeChargeEventCreateDataRequest}> = (props) => {
          const {fundFamilyId,data} = props ?? {};

          return  feeChargeEventCreate(fundFamilyId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FeeChargeEventCreateMutationResult = NonNullable<Awaited<ReturnType<typeof feeChargeEventCreate>>>
    export type FeeChargeEventCreateMutationBody = FeeChargeEventCreateDataRequest
    export type FeeChargeEventCreateMutationError = unknown

    export const useFeeChargeEventCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof feeChargeEventCreate>>, TError,{fundFamilyId: string;data: FeeChargeEventCreateDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getFeeChargeEventCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Get a FeeChargeEvent
 */
export const feeChargeEventRetrieve = (
    fundFamilyId: string,
    feeChargeEventId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<FeeChargeEventPageData>(
      {url: `/fund-family/${fundFamilyId}/fee-charge-event/${feeChargeEventId}/`, method: 'GET', signal
    },
      options);
    }
  

export const getFeeChargeEventRetrieveQueryKey = (fundFamilyId: string,
    feeChargeEventId: string,) => {
    return [`/fund-family/${fundFamilyId}/fee-charge-event/${feeChargeEventId}/`] as const;
    }

    
export const getFeeChargeEventRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof feeChargeEventRetrieve>>, TError = unknown>(fundFamilyId: string,
    feeChargeEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feeChargeEventRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeeChargeEventRetrieveQueryKey(fundFamilyId,feeChargeEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feeChargeEventRetrieve>>> = ({ signal }) => feeChargeEventRetrieve(fundFamilyId,feeChargeEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && feeChargeEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof feeChargeEventRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FeeChargeEventRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof feeChargeEventRetrieve>>>
export type FeeChargeEventRetrieveQueryError = unknown

export const useFeeChargeEventRetrieve = <TData = Awaited<ReturnType<typeof feeChargeEventRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    feeChargeEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feeChargeEventRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeeChargeEventRetrieveQueryOptions(fundFamilyId,feeChargeEventId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFeeChargeEventRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof feeChargeEventRetrieve>>, TError = unknown>(fundFamilyId: string,
    feeChargeEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeChargeEventRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeeChargeEventRetrieveQueryKey(fundFamilyId,feeChargeEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feeChargeEventRetrieve>>> = ({ signal }) => feeChargeEventRetrieve(fundFamilyId,feeChargeEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && feeChargeEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeChargeEventRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FeeChargeEventRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof feeChargeEventRetrieve>>>
export type FeeChargeEventRetrieveSuspenseQueryError = unknown

export const useFeeChargeEventRetrieveSuspense = <TData = Awaited<ReturnType<typeof feeChargeEventRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    feeChargeEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeChargeEventRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeeChargeEventRetrieveSuspenseQueryOptions(fundFamilyId,feeChargeEventId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getFeeChargeEventRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,feeChargeEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,feeChargeEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && feeChargeEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getFeeChargeEventRetrieveQueryKey(fundFamilyId,feeChargeEventId),
              queryFn: () => feeChargeEventRetrieve(fundFamilyId,feeChargeEventId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Delete a FeeChargeEvent
 */
export const feeChargeEventDelete = (
    fundFamilyId: string,
    feeChargeEventId: string,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/fund-family/${fundFamilyId}/fee-charge-event/${feeChargeEventId}/`, method: 'DELETE'
    },
      options);
    }
  


export const getFeeChargeEventDeleteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof feeChargeEventDelete>>, TError,{fundFamilyId: string;feeChargeEventId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof feeChargeEventDelete>>, TError,{fundFamilyId: string;feeChargeEventId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof feeChargeEventDelete>>, {fundFamilyId: string;feeChargeEventId: string}> = (props) => {
          const {fundFamilyId,feeChargeEventId} = props ?? {};

          return  feeChargeEventDelete(fundFamilyId,feeChargeEventId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FeeChargeEventDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof feeChargeEventDelete>>>
    
    export type FeeChargeEventDeleteMutationError = unknown

    export const useFeeChargeEventDelete = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof feeChargeEventDelete>>, TError,{fundFamilyId: string;feeChargeEventId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getFeeChargeEventDeleteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Get the fee basis change by use for a fee charge event.
 */
export const feeChargeEventBasisChangeByUseRetrieve = (
    fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeeChargeEventBasisChangeByUseRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<FeeBasisChangeByUseData>(
      {url: `/fund-family/${fundFamilyId}/fee-charge-event/${feeChargeEventId}/basis-change-by-use`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getFeeChargeEventBasisChangeByUseRetrieveQueryKey = (fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeeChargeEventBasisChangeByUseRetrieveParams,) => {
    return [`/fund-family/${fundFamilyId}/fee-charge-event/${feeChargeEventId}/basis-change-by-use`, ...(params ? [params]: [])] as const;
    }

    
export const getFeeChargeEventBasisChangeByUseRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof feeChargeEventBasisChangeByUseRetrieve>>, TError = unknown>(fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeeChargeEventBasisChangeByUseRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feeChargeEventBasisChangeByUseRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeeChargeEventBasisChangeByUseRetrieveQueryKey(fundFamilyId,feeChargeEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feeChargeEventBasisChangeByUseRetrieve>>> = ({ signal }) => feeChargeEventBasisChangeByUseRetrieve(fundFamilyId,feeChargeEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && feeChargeEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof feeChargeEventBasisChangeByUseRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FeeChargeEventBasisChangeByUseRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof feeChargeEventBasisChangeByUseRetrieve>>>
export type FeeChargeEventBasisChangeByUseRetrieveQueryError = unknown

export const useFeeChargeEventBasisChangeByUseRetrieve = <TData = Awaited<ReturnType<typeof feeChargeEventBasisChangeByUseRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeeChargeEventBasisChangeByUseRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feeChargeEventBasisChangeByUseRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeeChargeEventBasisChangeByUseRetrieveQueryOptions(fundFamilyId,feeChargeEventId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFeeChargeEventBasisChangeByUseRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof feeChargeEventBasisChangeByUseRetrieve>>, TError = unknown>(fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeeChargeEventBasisChangeByUseRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeChargeEventBasisChangeByUseRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeeChargeEventBasisChangeByUseRetrieveQueryKey(fundFamilyId,feeChargeEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feeChargeEventBasisChangeByUseRetrieve>>> = ({ signal }) => feeChargeEventBasisChangeByUseRetrieve(fundFamilyId,feeChargeEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && feeChargeEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeChargeEventBasisChangeByUseRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FeeChargeEventBasisChangeByUseRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof feeChargeEventBasisChangeByUseRetrieve>>>
export type FeeChargeEventBasisChangeByUseRetrieveSuspenseQueryError = unknown

export const useFeeChargeEventBasisChangeByUseRetrieveSuspense = <TData = Awaited<ReturnType<typeof feeChargeEventBasisChangeByUseRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeeChargeEventBasisChangeByUseRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeChargeEventBasisChangeByUseRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeeChargeEventBasisChangeByUseRetrieveSuspenseQueryOptions(fundFamilyId,feeChargeEventId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getFeeChargeEventBasisChangeByUseRetrieveLoader = (queryParamsOrFn?: (FeeChargeEventBasisChangeByUseRetrieveParams | ((params: Params) => FeeChargeEventBasisChangeByUseRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,feeChargeEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,feeChargeEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId && feeChargeEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getFeeChargeEventBasisChangeByUseRetrieveQueryKey(fundFamilyId,feeChargeEventId, queryParams),
              queryFn: () => feeChargeEventBasisChangeByUseRetrieve(fundFamilyId,feeChargeEventId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Get the fee basis breakdown for a fee charge event
 */
export const feeChargeEventBasisBreakdownBySecurityOwnershipRetrieve = (
    fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeeChargeEventBasisBreakdownBySecurityOwnershipRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/fund-family/${fundFamilyId}/fee-charge-event/${feeChargeEventId}/fee-basis-by-security-ownership`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getFeeChargeEventBasisBreakdownBySecurityOwnershipRetrieveQueryKey = (fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeeChargeEventBasisBreakdownBySecurityOwnershipRetrieveParams,) => {
    return [`/fund-family/${fundFamilyId}/fee-charge-event/${feeChargeEventId}/fee-basis-by-security-ownership`, ...(params ? [params]: [])] as const;
    }

    
export const getFeeChargeEventBasisBreakdownBySecurityOwnershipRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof feeChargeEventBasisBreakdownBySecurityOwnershipRetrieve>>, TError = unknown>(fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeeChargeEventBasisBreakdownBySecurityOwnershipRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feeChargeEventBasisBreakdownBySecurityOwnershipRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeeChargeEventBasisBreakdownBySecurityOwnershipRetrieveQueryKey(fundFamilyId,feeChargeEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feeChargeEventBasisBreakdownBySecurityOwnershipRetrieve>>> = ({ signal }) => feeChargeEventBasisBreakdownBySecurityOwnershipRetrieve(fundFamilyId,feeChargeEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && feeChargeEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof feeChargeEventBasisBreakdownBySecurityOwnershipRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FeeChargeEventBasisBreakdownBySecurityOwnershipRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof feeChargeEventBasisBreakdownBySecurityOwnershipRetrieve>>>
export type FeeChargeEventBasisBreakdownBySecurityOwnershipRetrieveQueryError = unknown

export const useFeeChargeEventBasisBreakdownBySecurityOwnershipRetrieve = <TData = Awaited<ReturnType<typeof feeChargeEventBasisBreakdownBySecurityOwnershipRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeeChargeEventBasisBreakdownBySecurityOwnershipRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feeChargeEventBasisBreakdownBySecurityOwnershipRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeeChargeEventBasisBreakdownBySecurityOwnershipRetrieveQueryOptions(fundFamilyId,feeChargeEventId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFeeChargeEventBasisBreakdownBySecurityOwnershipRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof feeChargeEventBasisBreakdownBySecurityOwnershipRetrieve>>, TError = unknown>(fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeeChargeEventBasisBreakdownBySecurityOwnershipRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeChargeEventBasisBreakdownBySecurityOwnershipRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeeChargeEventBasisBreakdownBySecurityOwnershipRetrieveQueryKey(fundFamilyId,feeChargeEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feeChargeEventBasisBreakdownBySecurityOwnershipRetrieve>>> = ({ signal }) => feeChargeEventBasisBreakdownBySecurityOwnershipRetrieve(fundFamilyId,feeChargeEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && feeChargeEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeChargeEventBasisBreakdownBySecurityOwnershipRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FeeChargeEventBasisBreakdownBySecurityOwnershipRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof feeChargeEventBasisBreakdownBySecurityOwnershipRetrieve>>>
export type FeeChargeEventBasisBreakdownBySecurityOwnershipRetrieveSuspenseQueryError = unknown

export const useFeeChargeEventBasisBreakdownBySecurityOwnershipRetrieveSuspense = <TData = Awaited<ReturnType<typeof feeChargeEventBasisBreakdownBySecurityOwnershipRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeeChargeEventBasisBreakdownBySecurityOwnershipRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeChargeEventBasisBreakdownBySecurityOwnershipRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeeChargeEventBasisBreakdownBySecurityOwnershipRetrieveSuspenseQueryOptions(fundFamilyId,feeChargeEventId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getFeeChargeEventBasisBreakdownBySecurityOwnershipRetrieveLoader = (queryParamsOrFn?: (FeeChargeEventBasisBreakdownBySecurityOwnershipRetrieveParams | ((params: Params) => FeeChargeEventBasisBreakdownBySecurityOwnershipRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,feeChargeEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,feeChargeEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId && feeChargeEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getFeeChargeEventBasisBreakdownBySecurityOwnershipRetrieveQueryKey(fundFamilyId,feeChargeEventId, queryParams),
              queryFn: () => feeChargeEventBasisBreakdownBySecurityOwnershipRetrieve(fundFamilyId,feeChargeEventId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Get the fee basis breakdown for a fee charge event
 */
export const feeChargeEventBasisBreakdownByUseRetrieve = (
    fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeeChargeEventBasisBreakdownByUseRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/fund-family/${fundFamilyId}/fee-charge-event/${feeChargeEventId}/fee-basis-by-use`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getFeeChargeEventBasisBreakdownByUseRetrieveQueryKey = (fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeeChargeEventBasisBreakdownByUseRetrieveParams,) => {
    return [`/fund-family/${fundFamilyId}/fee-charge-event/${feeChargeEventId}/fee-basis-by-use`, ...(params ? [params]: [])] as const;
    }

    
export const getFeeChargeEventBasisBreakdownByUseRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof feeChargeEventBasisBreakdownByUseRetrieve>>, TError = unknown>(fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeeChargeEventBasisBreakdownByUseRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feeChargeEventBasisBreakdownByUseRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeeChargeEventBasisBreakdownByUseRetrieveQueryKey(fundFamilyId,feeChargeEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feeChargeEventBasisBreakdownByUseRetrieve>>> = ({ signal }) => feeChargeEventBasisBreakdownByUseRetrieve(fundFamilyId,feeChargeEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && feeChargeEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof feeChargeEventBasisBreakdownByUseRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FeeChargeEventBasisBreakdownByUseRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof feeChargeEventBasisBreakdownByUseRetrieve>>>
export type FeeChargeEventBasisBreakdownByUseRetrieveQueryError = unknown

export const useFeeChargeEventBasisBreakdownByUseRetrieve = <TData = Awaited<ReturnType<typeof feeChargeEventBasisBreakdownByUseRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeeChargeEventBasisBreakdownByUseRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feeChargeEventBasisBreakdownByUseRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeeChargeEventBasisBreakdownByUseRetrieveQueryOptions(fundFamilyId,feeChargeEventId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFeeChargeEventBasisBreakdownByUseRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof feeChargeEventBasisBreakdownByUseRetrieve>>, TError = unknown>(fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeeChargeEventBasisBreakdownByUseRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeChargeEventBasisBreakdownByUseRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeeChargeEventBasisBreakdownByUseRetrieveQueryKey(fundFamilyId,feeChargeEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feeChargeEventBasisBreakdownByUseRetrieve>>> = ({ signal }) => feeChargeEventBasisBreakdownByUseRetrieve(fundFamilyId,feeChargeEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && feeChargeEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeChargeEventBasisBreakdownByUseRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FeeChargeEventBasisBreakdownByUseRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof feeChargeEventBasisBreakdownByUseRetrieve>>>
export type FeeChargeEventBasisBreakdownByUseRetrieveSuspenseQueryError = unknown

export const useFeeChargeEventBasisBreakdownByUseRetrieveSuspense = <TData = Awaited<ReturnType<typeof feeChargeEventBasisBreakdownByUseRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeeChargeEventBasisBreakdownByUseRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeChargeEventBasisBreakdownByUseRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeeChargeEventBasisBreakdownByUseRetrieveSuspenseQueryOptions(fundFamilyId,feeChargeEventId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getFeeChargeEventBasisBreakdownByUseRetrieveLoader = (queryParamsOrFn?: (FeeChargeEventBasisBreakdownByUseRetrieveParams | ((params: Params) => FeeChargeEventBasisBreakdownByUseRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,feeChargeEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,feeChargeEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId && feeChargeEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getFeeChargeEventBasisBreakdownByUseRetrieveQueryKey(fundFamilyId,feeChargeEventId, queryParams),
              queryFn: () => feeChargeEventBasisBreakdownByUseRetrieve(fundFamilyId,feeChargeEventId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Get the fee basis stats for a fee charge event split out by fee basis and fee category
 */
export const feeChargeEventBasisStatsRetrieve = (
    fundFamilyId: string,
    feeChargeEventId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<FeeBasesStatsData>(
      {url: `/fund-family/${fundFamilyId}/fee-charge-event/${feeChargeEventId}/fee-basis-stats/`, method: 'GET', signal
    },
      options);
    }
  

export const getFeeChargeEventBasisStatsRetrieveQueryKey = (fundFamilyId: string,
    feeChargeEventId: string,) => {
    return [`/fund-family/${fundFamilyId}/fee-charge-event/${feeChargeEventId}/fee-basis-stats/`] as const;
    }

    
export const getFeeChargeEventBasisStatsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof feeChargeEventBasisStatsRetrieve>>, TError = unknown>(fundFamilyId: string,
    feeChargeEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feeChargeEventBasisStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeeChargeEventBasisStatsRetrieveQueryKey(fundFamilyId,feeChargeEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feeChargeEventBasisStatsRetrieve>>> = ({ signal }) => feeChargeEventBasisStatsRetrieve(fundFamilyId,feeChargeEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && feeChargeEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof feeChargeEventBasisStatsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FeeChargeEventBasisStatsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof feeChargeEventBasisStatsRetrieve>>>
export type FeeChargeEventBasisStatsRetrieveQueryError = unknown

export const useFeeChargeEventBasisStatsRetrieve = <TData = Awaited<ReturnType<typeof feeChargeEventBasisStatsRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    feeChargeEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feeChargeEventBasisStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeeChargeEventBasisStatsRetrieveQueryOptions(fundFamilyId,feeChargeEventId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFeeChargeEventBasisStatsRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof feeChargeEventBasisStatsRetrieve>>, TError = unknown>(fundFamilyId: string,
    feeChargeEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeChargeEventBasisStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeeChargeEventBasisStatsRetrieveQueryKey(fundFamilyId,feeChargeEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feeChargeEventBasisStatsRetrieve>>> = ({ signal }) => feeChargeEventBasisStatsRetrieve(fundFamilyId,feeChargeEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && feeChargeEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeChargeEventBasisStatsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FeeChargeEventBasisStatsRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof feeChargeEventBasisStatsRetrieve>>>
export type FeeChargeEventBasisStatsRetrieveSuspenseQueryError = unknown

export const useFeeChargeEventBasisStatsRetrieveSuspense = <TData = Awaited<ReturnType<typeof feeChargeEventBasisStatsRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    feeChargeEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeChargeEventBasisStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeeChargeEventBasisStatsRetrieveSuspenseQueryOptions(fundFamilyId,feeChargeEventId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getFeeChargeEventBasisStatsRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,feeChargeEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,feeChargeEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && feeChargeEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getFeeChargeEventBasisStatsRetrieveQueryKey(fundFamilyId,feeChargeEventId),
              queryFn: () => feeChargeEventBasisStatsRetrieve(fundFamilyId,feeChargeEventId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * List fee offset applications for fee charge event
 */
export const feeOffsetApplicationsList = (
    fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeeOffsetApplicationsListParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<FeeOffsetApplicationFormReadData>(
      {url: `/fund-family/${fundFamilyId}/fee-charge-event/${feeChargeEventId}/fee-offset-applications/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getFeeOffsetApplicationsListQueryKey = (fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeeOffsetApplicationsListParams,) => {
    return [`/fund-family/${fundFamilyId}/fee-charge-event/${feeChargeEventId}/fee-offset-applications/`, ...(params ? [params]: [])] as const;
    }

    
export const getFeeOffsetApplicationsListQueryOptions = <TData = Awaited<ReturnType<typeof feeOffsetApplicationsList>>, TError = unknown>(fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeeOffsetApplicationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feeOffsetApplicationsList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeeOffsetApplicationsListQueryKey(fundFamilyId,feeChargeEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feeOffsetApplicationsList>>> = ({ signal }) => feeOffsetApplicationsList(fundFamilyId,feeChargeEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && feeChargeEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof feeOffsetApplicationsList>>, TError, TData> & { queryKey: QueryKey }
}

export type FeeOffsetApplicationsListQueryResult = NonNullable<Awaited<ReturnType<typeof feeOffsetApplicationsList>>>
export type FeeOffsetApplicationsListQueryError = unknown

export const useFeeOffsetApplicationsList = <TData = Awaited<ReturnType<typeof feeOffsetApplicationsList>>, TError = unknown>(
 fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeeOffsetApplicationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feeOffsetApplicationsList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeeOffsetApplicationsListQueryOptions(fundFamilyId,feeChargeEventId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFeeOffsetApplicationsListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof feeOffsetApplicationsList>>, TError = unknown>(fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeeOffsetApplicationsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeOffsetApplicationsList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeeOffsetApplicationsListQueryKey(fundFamilyId,feeChargeEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feeOffsetApplicationsList>>> = ({ signal }) => feeOffsetApplicationsList(fundFamilyId,feeChargeEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && feeChargeEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeOffsetApplicationsList>>, TError, TData> & { queryKey: QueryKey }
}

export type FeeOffsetApplicationsListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof feeOffsetApplicationsList>>>
export type FeeOffsetApplicationsListSuspenseQueryError = unknown

export const useFeeOffsetApplicationsListSuspense = <TData = Awaited<ReturnType<typeof feeOffsetApplicationsList>>, TError = unknown>(
 fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeeOffsetApplicationsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeOffsetApplicationsList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeeOffsetApplicationsListSuspenseQueryOptions(fundFamilyId,feeChargeEventId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getFeeOffsetApplicationsListLoader = (queryParamsOrFn?: (FeeOffsetApplicationsListParams | ((params: Params) => FeeOffsetApplicationsListParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,feeChargeEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,feeChargeEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId && feeChargeEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getFeeOffsetApplicationsListQueryKey(fundFamilyId,feeChargeEventId, queryParams),
              queryFn: () => feeOffsetApplicationsList(fundFamilyId,feeChargeEventId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Upsert fee offset applications for fee charge event
 */
export const feeOffsetApplicationsUpsert = (
    fundFamilyId: string,
    feeChargeEventId: string,
    feeOffsetApplicationsFormUpsertDataRequest: FeeOffsetApplicationsFormUpsertDataRequest,
    params?: FeeOffsetApplicationsUpsertParams,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<FeeOffsetApplicationReadDataList>(
      {url: `/fund-family/${fundFamilyId}/fee-charge-event/${feeChargeEventId}/fee-offset-applications/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: feeOffsetApplicationsFormUpsertDataRequest,
        params
    },
      options);
    }
  


export const getFeeOffsetApplicationsUpsertMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof feeOffsetApplicationsUpsert>>, TError,{fundFamilyId: string;feeChargeEventId: string;data: FeeOffsetApplicationsFormUpsertDataRequest;params?: FeeOffsetApplicationsUpsertParams}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof feeOffsetApplicationsUpsert>>, TError,{fundFamilyId: string;feeChargeEventId: string;data: FeeOffsetApplicationsFormUpsertDataRequest;params?: FeeOffsetApplicationsUpsertParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof feeOffsetApplicationsUpsert>>, {fundFamilyId: string;feeChargeEventId: string;data: FeeOffsetApplicationsFormUpsertDataRequest;params?: FeeOffsetApplicationsUpsertParams}> = (props) => {
          const {fundFamilyId,feeChargeEventId,data,params} = props ?? {};

          return  feeOffsetApplicationsUpsert(fundFamilyId,feeChargeEventId,data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FeeOffsetApplicationsUpsertMutationResult = NonNullable<Awaited<ReturnType<typeof feeOffsetApplicationsUpsert>>>
    export type FeeOffsetApplicationsUpsertMutationBody = FeeOffsetApplicationsFormUpsertDataRequest
    export type FeeOffsetApplicationsUpsertMutationError = unknown

    export const useFeeOffsetApplicationsUpsert = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof feeOffsetApplicationsUpsert>>, TError,{fundFamilyId: string;feeChargeEventId: string;data: FeeOffsetApplicationsFormUpsertDataRequest;params?: FeeOffsetApplicationsUpsertParams}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getFeeOffsetApplicationsUpsertMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Create adjustment fund family event for late fee offset application
 */
export const adjustmentEventForLateFeeOffsetApplicationsCreate = (
    fundFamilyId: string,
    feeChargeEventId: string,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<FundFamilyEventData>(
      {url: `/fund-family/${fundFamilyId}/fee-charge-event/${feeChargeEventId}/fee-offset-applications/create-late-offset-adjustment-event/`, method: 'POST'
    },
      options);
    }
  


export const getAdjustmentEventForLateFeeOffsetApplicationsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adjustmentEventForLateFeeOffsetApplicationsCreate>>, TError,{fundFamilyId: string;feeChargeEventId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof adjustmentEventForLateFeeOffsetApplicationsCreate>>, TError,{fundFamilyId: string;feeChargeEventId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adjustmentEventForLateFeeOffsetApplicationsCreate>>, {fundFamilyId: string;feeChargeEventId: string}> = (props) => {
          const {fundFamilyId,feeChargeEventId} = props ?? {};

          return  adjustmentEventForLateFeeOffsetApplicationsCreate(fundFamilyId,feeChargeEventId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdjustmentEventForLateFeeOffsetApplicationsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof adjustmentEventForLateFeeOffsetApplicationsCreate>>>
    
    export type AdjustmentEventForLateFeeOffsetApplicationsCreateMutationError = unknown

    export const useAdjustmentEventForLateFeeOffsetApplicationsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adjustmentEventForLateFeeOffsetApplicationsCreate>>, TError,{fundFamilyId: string;feeChargeEventId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getAdjustmentEventForLateFeeOffsetApplicationsCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Get the fee offset summary table for a fee charge event
 */
export const feeOffsetSummaryForFeeChargeEventTableDataRetrieve = (
    fundFamilyId: string,
    feeChargeEventId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/fund-family/${fundFamilyId}/fee-charge-event/${feeChargeEventId}/fee-offset-summary-table-data/`, method: 'GET', signal
    },
      options);
    }
  

export const getFeeOffsetSummaryForFeeChargeEventTableDataRetrieveQueryKey = (fundFamilyId: string,
    feeChargeEventId: string,) => {
    return [`/fund-family/${fundFamilyId}/fee-charge-event/${feeChargeEventId}/fee-offset-summary-table-data/`] as const;
    }

    
export const getFeeOffsetSummaryForFeeChargeEventTableDataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof feeOffsetSummaryForFeeChargeEventTableDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    feeChargeEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feeOffsetSummaryForFeeChargeEventTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeeOffsetSummaryForFeeChargeEventTableDataRetrieveQueryKey(fundFamilyId,feeChargeEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feeOffsetSummaryForFeeChargeEventTableDataRetrieve>>> = ({ signal }) => feeOffsetSummaryForFeeChargeEventTableDataRetrieve(fundFamilyId,feeChargeEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && feeChargeEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof feeOffsetSummaryForFeeChargeEventTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FeeOffsetSummaryForFeeChargeEventTableDataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof feeOffsetSummaryForFeeChargeEventTableDataRetrieve>>>
export type FeeOffsetSummaryForFeeChargeEventTableDataRetrieveQueryError = unknown

export const useFeeOffsetSummaryForFeeChargeEventTableDataRetrieve = <TData = Awaited<ReturnType<typeof feeOffsetSummaryForFeeChargeEventTableDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    feeChargeEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feeOffsetSummaryForFeeChargeEventTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeeOffsetSummaryForFeeChargeEventTableDataRetrieveQueryOptions(fundFamilyId,feeChargeEventId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFeeOffsetSummaryForFeeChargeEventTableDataRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof feeOffsetSummaryForFeeChargeEventTableDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    feeChargeEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeOffsetSummaryForFeeChargeEventTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeeOffsetSummaryForFeeChargeEventTableDataRetrieveQueryKey(fundFamilyId,feeChargeEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feeOffsetSummaryForFeeChargeEventTableDataRetrieve>>> = ({ signal }) => feeOffsetSummaryForFeeChargeEventTableDataRetrieve(fundFamilyId,feeChargeEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && feeChargeEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeOffsetSummaryForFeeChargeEventTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FeeOffsetSummaryForFeeChargeEventTableDataRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof feeOffsetSummaryForFeeChargeEventTableDataRetrieve>>>
export type FeeOffsetSummaryForFeeChargeEventTableDataRetrieveSuspenseQueryError = unknown

export const useFeeOffsetSummaryForFeeChargeEventTableDataRetrieveSuspense = <TData = Awaited<ReturnType<typeof feeOffsetSummaryForFeeChargeEventTableDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    feeChargeEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeOffsetSummaryForFeeChargeEventTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeeOffsetSummaryForFeeChargeEventTableDataRetrieveSuspenseQueryOptions(fundFamilyId,feeChargeEventId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getFeeOffsetSummaryForFeeChargeEventTableDataRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,feeChargeEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,feeChargeEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && feeChargeEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getFeeOffsetSummaryForFeeChargeEventTableDataRetrieveQueryKey(fundFamilyId,feeChargeEventId),
              queryFn: () => feeOffsetSummaryForFeeChargeEventTableDataRetrieve(fundFamilyId,feeChargeEventId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Get a fee offset table data for fee charge event
 */
export const feeOffsetTableDataForFeeChargeEventRetrieve = (
    fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeeOffsetTableDataForFeeChargeEventRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/fund-family/${fundFamilyId}/fee-charge-event/${feeChargeEventId}/fee-offset-table-data/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getFeeOffsetTableDataForFeeChargeEventRetrieveQueryKey = (fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeeOffsetTableDataForFeeChargeEventRetrieveParams,) => {
    return [`/fund-family/${fundFamilyId}/fee-charge-event/${feeChargeEventId}/fee-offset-table-data/`, ...(params ? [params]: [])] as const;
    }

    
export const getFeeOffsetTableDataForFeeChargeEventRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof feeOffsetTableDataForFeeChargeEventRetrieve>>, TError = unknown>(fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeeOffsetTableDataForFeeChargeEventRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feeOffsetTableDataForFeeChargeEventRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeeOffsetTableDataForFeeChargeEventRetrieveQueryKey(fundFamilyId,feeChargeEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feeOffsetTableDataForFeeChargeEventRetrieve>>> = ({ signal }) => feeOffsetTableDataForFeeChargeEventRetrieve(fundFamilyId,feeChargeEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && feeChargeEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof feeOffsetTableDataForFeeChargeEventRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FeeOffsetTableDataForFeeChargeEventRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof feeOffsetTableDataForFeeChargeEventRetrieve>>>
export type FeeOffsetTableDataForFeeChargeEventRetrieveQueryError = unknown

export const useFeeOffsetTableDataForFeeChargeEventRetrieve = <TData = Awaited<ReturnType<typeof feeOffsetTableDataForFeeChargeEventRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeeOffsetTableDataForFeeChargeEventRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feeOffsetTableDataForFeeChargeEventRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeeOffsetTableDataForFeeChargeEventRetrieveQueryOptions(fundFamilyId,feeChargeEventId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFeeOffsetTableDataForFeeChargeEventRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof feeOffsetTableDataForFeeChargeEventRetrieve>>, TError = unknown>(fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeeOffsetTableDataForFeeChargeEventRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeOffsetTableDataForFeeChargeEventRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeeOffsetTableDataForFeeChargeEventRetrieveQueryKey(fundFamilyId,feeChargeEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feeOffsetTableDataForFeeChargeEventRetrieve>>> = ({ signal }) => feeOffsetTableDataForFeeChargeEventRetrieve(fundFamilyId,feeChargeEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && feeChargeEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeOffsetTableDataForFeeChargeEventRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FeeOffsetTableDataForFeeChargeEventRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof feeOffsetTableDataForFeeChargeEventRetrieve>>>
export type FeeOffsetTableDataForFeeChargeEventRetrieveSuspenseQueryError = unknown

export const useFeeOffsetTableDataForFeeChargeEventRetrieveSuspense = <TData = Awaited<ReturnType<typeof feeOffsetTableDataForFeeChargeEventRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeeOffsetTableDataForFeeChargeEventRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeOffsetTableDataForFeeChargeEventRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeeOffsetTableDataForFeeChargeEventRetrieveSuspenseQueryOptions(fundFamilyId,feeChargeEventId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getFeeOffsetTableDataForFeeChargeEventRetrieveLoader = (queryParamsOrFn?: (FeeOffsetTableDataForFeeChargeEventRetrieveParams | ((params: Params) => FeeOffsetTableDataForFeeChargeEventRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,feeChargeEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,feeChargeEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId && feeChargeEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getFeeOffsetTableDataForFeeChargeEventRetrieveQueryKey(fundFamilyId,feeChargeEventId, queryParams),
              queryFn: () => feeOffsetTableDataForFeeChargeEventRetrieve(fundFamilyId,feeChargeEventId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Get list of fee periods that are affected by the true up event
 */
export const feePeriodsAffectedByTrueUpRetrieve = (
    fundFamilyId: string,
    feeChargeEventId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericSelectDataList>(
      {url: `/fund-family/${fundFamilyId}/fee-charge-event/${feeChargeEventId}/fee-period-select/`, method: 'GET', signal
    },
      options);
    }
  

export const getFeePeriodsAffectedByTrueUpRetrieveQueryKey = (fundFamilyId: string,
    feeChargeEventId: string,) => {
    return [`/fund-family/${fundFamilyId}/fee-charge-event/${feeChargeEventId}/fee-period-select/`] as const;
    }

    
export const getFeePeriodsAffectedByTrueUpRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof feePeriodsAffectedByTrueUpRetrieve>>, TError = unknown>(fundFamilyId: string,
    feeChargeEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feePeriodsAffectedByTrueUpRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeePeriodsAffectedByTrueUpRetrieveQueryKey(fundFamilyId,feeChargeEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feePeriodsAffectedByTrueUpRetrieve>>> = ({ signal }) => feePeriodsAffectedByTrueUpRetrieve(fundFamilyId,feeChargeEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && feeChargeEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof feePeriodsAffectedByTrueUpRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FeePeriodsAffectedByTrueUpRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof feePeriodsAffectedByTrueUpRetrieve>>>
export type FeePeriodsAffectedByTrueUpRetrieveQueryError = unknown

export const useFeePeriodsAffectedByTrueUpRetrieve = <TData = Awaited<ReturnType<typeof feePeriodsAffectedByTrueUpRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    feeChargeEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feePeriodsAffectedByTrueUpRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeePeriodsAffectedByTrueUpRetrieveQueryOptions(fundFamilyId,feeChargeEventId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFeePeriodsAffectedByTrueUpRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof feePeriodsAffectedByTrueUpRetrieve>>, TError = unknown>(fundFamilyId: string,
    feeChargeEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feePeriodsAffectedByTrueUpRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeePeriodsAffectedByTrueUpRetrieveQueryKey(fundFamilyId,feeChargeEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feePeriodsAffectedByTrueUpRetrieve>>> = ({ signal }) => feePeriodsAffectedByTrueUpRetrieve(fundFamilyId,feeChargeEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && feeChargeEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof feePeriodsAffectedByTrueUpRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FeePeriodsAffectedByTrueUpRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof feePeriodsAffectedByTrueUpRetrieve>>>
export type FeePeriodsAffectedByTrueUpRetrieveSuspenseQueryError = unknown

export const useFeePeriodsAffectedByTrueUpRetrieveSuspense = <TData = Awaited<ReturnType<typeof feePeriodsAffectedByTrueUpRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    feeChargeEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feePeriodsAffectedByTrueUpRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeePeriodsAffectedByTrueUpRetrieveSuspenseQueryOptions(fundFamilyId,feeChargeEventId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getFeePeriodsAffectedByTrueUpRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,feeChargeEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,feeChargeEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && feeChargeEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getFeePeriodsAffectedByTrueUpRetrieveQueryKey(fundFamilyId,feeChargeEventId),
              queryFn: () => feePeriodsAffectedByTrueUpRetrieve(fundFamilyId,feeChargeEventId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Get the fee waiver offset summary table for a fee charge event
 */
export const feeWaiverOffsetSummaryForFeeChargeEventTableDataRetrieve = (
    fundFamilyId: string,
    feeChargeEventId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/fund-family/${fundFamilyId}/fee-charge-event/${feeChargeEventId}/fee-waiver-offset-summary-table-data/`, method: 'GET', signal
    },
      options);
    }
  

export const getFeeWaiverOffsetSummaryForFeeChargeEventTableDataRetrieveQueryKey = (fundFamilyId: string,
    feeChargeEventId: string,) => {
    return [`/fund-family/${fundFamilyId}/fee-charge-event/${feeChargeEventId}/fee-waiver-offset-summary-table-data/`] as const;
    }

    
export const getFeeWaiverOffsetSummaryForFeeChargeEventTableDataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof feeWaiverOffsetSummaryForFeeChargeEventTableDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    feeChargeEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feeWaiverOffsetSummaryForFeeChargeEventTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeeWaiverOffsetSummaryForFeeChargeEventTableDataRetrieveQueryKey(fundFamilyId,feeChargeEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feeWaiverOffsetSummaryForFeeChargeEventTableDataRetrieve>>> = ({ signal }) => feeWaiverOffsetSummaryForFeeChargeEventTableDataRetrieve(fundFamilyId,feeChargeEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && feeChargeEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof feeWaiverOffsetSummaryForFeeChargeEventTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FeeWaiverOffsetSummaryForFeeChargeEventTableDataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof feeWaiverOffsetSummaryForFeeChargeEventTableDataRetrieve>>>
export type FeeWaiverOffsetSummaryForFeeChargeEventTableDataRetrieveQueryError = unknown

export const useFeeWaiverOffsetSummaryForFeeChargeEventTableDataRetrieve = <TData = Awaited<ReturnType<typeof feeWaiverOffsetSummaryForFeeChargeEventTableDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    feeChargeEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feeWaiverOffsetSummaryForFeeChargeEventTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeeWaiverOffsetSummaryForFeeChargeEventTableDataRetrieveQueryOptions(fundFamilyId,feeChargeEventId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFeeWaiverOffsetSummaryForFeeChargeEventTableDataRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof feeWaiverOffsetSummaryForFeeChargeEventTableDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    feeChargeEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeWaiverOffsetSummaryForFeeChargeEventTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeeWaiverOffsetSummaryForFeeChargeEventTableDataRetrieveQueryKey(fundFamilyId,feeChargeEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feeWaiverOffsetSummaryForFeeChargeEventTableDataRetrieve>>> = ({ signal }) => feeWaiverOffsetSummaryForFeeChargeEventTableDataRetrieve(fundFamilyId,feeChargeEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && feeChargeEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeWaiverOffsetSummaryForFeeChargeEventTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FeeWaiverOffsetSummaryForFeeChargeEventTableDataRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof feeWaiverOffsetSummaryForFeeChargeEventTableDataRetrieve>>>
export type FeeWaiverOffsetSummaryForFeeChargeEventTableDataRetrieveSuspenseQueryError = unknown

export const useFeeWaiverOffsetSummaryForFeeChargeEventTableDataRetrieveSuspense = <TData = Awaited<ReturnType<typeof feeWaiverOffsetSummaryForFeeChargeEventTableDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    feeChargeEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeWaiverOffsetSummaryForFeeChargeEventTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeeWaiverOffsetSummaryForFeeChargeEventTableDataRetrieveSuspenseQueryOptions(fundFamilyId,feeChargeEventId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getFeeWaiverOffsetSummaryForFeeChargeEventTableDataRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,feeChargeEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,feeChargeEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && feeChargeEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getFeeWaiverOffsetSummaryForFeeChargeEventTableDataRetrieveQueryKey(fundFamilyId,feeChargeEventId),
              queryFn: () => feeWaiverOffsetSummaryForFeeChargeEventTableDataRetrieve(fundFamilyId,feeChargeEventId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Get table representing the historical basis true up breakdown for a particular fee period
 */
export const feePeriodHistoricalTrueUpBreakdownRetrieve = (
    fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeePeriodHistoricalTrueUpBreakdownRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/fund-family/${fundFamilyId}/fee-charge-event/${feeChargeEventId}/historical-true-up-breakdown/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getFeePeriodHistoricalTrueUpBreakdownRetrieveQueryKey = (fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeePeriodHistoricalTrueUpBreakdownRetrieveParams,) => {
    return [`/fund-family/${fundFamilyId}/fee-charge-event/${feeChargeEventId}/historical-true-up-breakdown/`, ...(params ? [params]: [])] as const;
    }

    
export const getFeePeriodHistoricalTrueUpBreakdownRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof feePeriodHistoricalTrueUpBreakdownRetrieve>>, TError = unknown>(fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeePeriodHistoricalTrueUpBreakdownRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feePeriodHistoricalTrueUpBreakdownRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeePeriodHistoricalTrueUpBreakdownRetrieveQueryKey(fundFamilyId,feeChargeEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feePeriodHistoricalTrueUpBreakdownRetrieve>>> = ({ signal }) => feePeriodHistoricalTrueUpBreakdownRetrieve(fundFamilyId,feeChargeEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && feeChargeEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof feePeriodHistoricalTrueUpBreakdownRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FeePeriodHistoricalTrueUpBreakdownRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof feePeriodHistoricalTrueUpBreakdownRetrieve>>>
export type FeePeriodHistoricalTrueUpBreakdownRetrieveQueryError = unknown

export const useFeePeriodHistoricalTrueUpBreakdownRetrieve = <TData = Awaited<ReturnType<typeof feePeriodHistoricalTrueUpBreakdownRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeePeriodHistoricalTrueUpBreakdownRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feePeriodHistoricalTrueUpBreakdownRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeePeriodHistoricalTrueUpBreakdownRetrieveQueryOptions(fundFamilyId,feeChargeEventId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFeePeriodHistoricalTrueUpBreakdownRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof feePeriodHistoricalTrueUpBreakdownRetrieve>>, TError = unknown>(fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeePeriodHistoricalTrueUpBreakdownRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feePeriodHistoricalTrueUpBreakdownRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeePeriodHistoricalTrueUpBreakdownRetrieveQueryKey(fundFamilyId,feeChargeEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feePeriodHistoricalTrueUpBreakdownRetrieve>>> = ({ signal }) => feePeriodHistoricalTrueUpBreakdownRetrieve(fundFamilyId,feeChargeEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && feeChargeEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof feePeriodHistoricalTrueUpBreakdownRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FeePeriodHistoricalTrueUpBreakdownRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof feePeriodHistoricalTrueUpBreakdownRetrieve>>>
export type FeePeriodHistoricalTrueUpBreakdownRetrieveSuspenseQueryError = unknown

export const useFeePeriodHistoricalTrueUpBreakdownRetrieveSuspense = <TData = Awaited<ReturnType<typeof feePeriodHistoricalTrueUpBreakdownRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeePeriodHistoricalTrueUpBreakdownRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feePeriodHistoricalTrueUpBreakdownRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeePeriodHistoricalTrueUpBreakdownRetrieveSuspenseQueryOptions(fundFamilyId,feeChargeEventId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getFeePeriodHistoricalTrueUpBreakdownRetrieveLoader = (queryParamsOrFn?: (FeePeriodHistoricalTrueUpBreakdownRetrieveParams | ((params: Params) => FeePeriodHistoricalTrueUpBreakdownRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,feeChargeEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,feeChargeEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId && feeChargeEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getFeePeriodHistoricalTrueUpBreakdownRetrieveQueryKey(fundFamilyId,feeChargeEventId, queryParams),
              queryFn: () => feePeriodHistoricalTrueUpBreakdownRetrieve(fundFamilyId,feeChargeEventId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Get stats for a historical fee true up preview
 */
export const feeTrueUpHistoricalPreviewStatsRetrieve = (
    fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeeTrueUpHistoricalPreviewStatsRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<PreviousQuarterFeeTrueUpHistoricalStatsAPIData>(
      {url: `/fund-family/${fundFamilyId}/fee-charge-event/${feeChargeEventId}/historical-true-up-stats/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getFeeTrueUpHistoricalPreviewStatsRetrieveQueryKey = (fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeeTrueUpHistoricalPreviewStatsRetrieveParams,) => {
    return [`/fund-family/${fundFamilyId}/fee-charge-event/${feeChargeEventId}/historical-true-up-stats/`, ...(params ? [params]: [])] as const;
    }

    
export const getFeeTrueUpHistoricalPreviewStatsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof feeTrueUpHistoricalPreviewStatsRetrieve>>, TError = unknown>(fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeeTrueUpHistoricalPreviewStatsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feeTrueUpHistoricalPreviewStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeeTrueUpHistoricalPreviewStatsRetrieveQueryKey(fundFamilyId,feeChargeEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feeTrueUpHistoricalPreviewStatsRetrieve>>> = ({ signal }) => feeTrueUpHistoricalPreviewStatsRetrieve(fundFamilyId,feeChargeEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && feeChargeEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof feeTrueUpHistoricalPreviewStatsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FeeTrueUpHistoricalPreviewStatsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof feeTrueUpHistoricalPreviewStatsRetrieve>>>
export type FeeTrueUpHistoricalPreviewStatsRetrieveQueryError = unknown

export const useFeeTrueUpHistoricalPreviewStatsRetrieve = <TData = Awaited<ReturnType<typeof feeTrueUpHistoricalPreviewStatsRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeeTrueUpHistoricalPreviewStatsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feeTrueUpHistoricalPreviewStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeeTrueUpHistoricalPreviewStatsRetrieveQueryOptions(fundFamilyId,feeChargeEventId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFeeTrueUpHistoricalPreviewStatsRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof feeTrueUpHistoricalPreviewStatsRetrieve>>, TError = unknown>(fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeeTrueUpHistoricalPreviewStatsRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeTrueUpHistoricalPreviewStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeeTrueUpHistoricalPreviewStatsRetrieveQueryKey(fundFamilyId,feeChargeEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feeTrueUpHistoricalPreviewStatsRetrieve>>> = ({ signal }) => feeTrueUpHistoricalPreviewStatsRetrieve(fundFamilyId,feeChargeEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && feeChargeEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeTrueUpHistoricalPreviewStatsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FeeTrueUpHistoricalPreviewStatsRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof feeTrueUpHistoricalPreviewStatsRetrieve>>>
export type FeeTrueUpHistoricalPreviewStatsRetrieveSuspenseQueryError = unknown

export const useFeeTrueUpHistoricalPreviewStatsRetrieveSuspense = <TData = Awaited<ReturnType<typeof feeTrueUpHistoricalPreviewStatsRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeeTrueUpHistoricalPreviewStatsRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeTrueUpHistoricalPreviewStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeeTrueUpHistoricalPreviewStatsRetrieveSuspenseQueryOptions(fundFamilyId,feeChargeEventId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getFeeTrueUpHistoricalPreviewStatsRetrieveLoader = (queryParamsOrFn?: (FeeTrueUpHistoricalPreviewStatsRetrieveParams | ((params: Params) => FeeTrueUpHistoricalPreviewStatsRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,feeChargeEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,feeChargeEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId && feeChargeEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getFeeTrueUpHistoricalPreviewStatsRetrieveQueryKey(fundFamilyId,feeChargeEventId, queryParams),
              queryFn: () => feeTrueUpHistoricalPreviewStatsRetrieve(fundFamilyId,feeChargeEventId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Get the breakdown for a fee period
 */
export const feeChargeEventPeriodBreakdownTableDataRetrieve = (
    fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeeChargeEventPeriodBreakdownTableDataRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<TableDataGroupedByEntity>(
      {url: `/fund-family/${fundFamilyId}/fee-charge-event/${feeChargeEventId}/period-breakdown`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getFeeChargeEventPeriodBreakdownTableDataRetrieveQueryKey = (fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeeChargeEventPeriodBreakdownTableDataRetrieveParams,) => {
    return [`/fund-family/${fundFamilyId}/fee-charge-event/${feeChargeEventId}/period-breakdown`, ...(params ? [params]: [])] as const;
    }

    
export const getFeeChargeEventPeriodBreakdownTableDataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof feeChargeEventPeriodBreakdownTableDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeeChargeEventPeriodBreakdownTableDataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feeChargeEventPeriodBreakdownTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeeChargeEventPeriodBreakdownTableDataRetrieveQueryKey(fundFamilyId,feeChargeEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feeChargeEventPeriodBreakdownTableDataRetrieve>>> = ({ signal }) => feeChargeEventPeriodBreakdownTableDataRetrieve(fundFamilyId,feeChargeEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && feeChargeEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof feeChargeEventPeriodBreakdownTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FeeChargeEventPeriodBreakdownTableDataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof feeChargeEventPeriodBreakdownTableDataRetrieve>>>
export type FeeChargeEventPeriodBreakdownTableDataRetrieveQueryError = unknown

export const useFeeChargeEventPeriodBreakdownTableDataRetrieve = <TData = Awaited<ReturnType<typeof feeChargeEventPeriodBreakdownTableDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeeChargeEventPeriodBreakdownTableDataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feeChargeEventPeriodBreakdownTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeeChargeEventPeriodBreakdownTableDataRetrieveQueryOptions(fundFamilyId,feeChargeEventId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFeeChargeEventPeriodBreakdownTableDataRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof feeChargeEventPeriodBreakdownTableDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeeChargeEventPeriodBreakdownTableDataRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeChargeEventPeriodBreakdownTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeeChargeEventPeriodBreakdownTableDataRetrieveQueryKey(fundFamilyId,feeChargeEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feeChargeEventPeriodBreakdownTableDataRetrieve>>> = ({ signal }) => feeChargeEventPeriodBreakdownTableDataRetrieve(fundFamilyId,feeChargeEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && feeChargeEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeChargeEventPeriodBreakdownTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FeeChargeEventPeriodBreakdownTableDataRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof feeChargeEventPeriodBreakdownTableDataRetrieve>>>
export type FeeChargeEventPeriodBreakdownTableDataRetrieveSuspenseQueryError = unknown

export const useFeeChargeEventPeriodBreakdownTableDataRetrieveSuspense = <TData = Awaited<ReturnType<typeof feeChargeEventPeriodBreakdownTableDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeeChargeEventPeriodBreakdownTableDataRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeChargeEventPeriodBreakdownTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeeChargeEventPeriodBreakdownTableDataRetrieveSuspenseQueryOptions(fundFamilyId,feeChargeEventId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getFeeChargeEventPeriodBreakdownTableDataRetrieveLoader = (queryParamsOrFn?: (FeeChargeEventPeriodBreakdownTableDataRetrieveParams | ((params: Params) => FeeChargeEventPeriodBreakdownTableDataRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,feeChargeEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,feeChargeEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId && feeChargeEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getFeeChargeEventPeriodBreakdownTableDataRetrieveQueryKey(fundFamilyId,feeChargeEventId, queryParams),
              queryFn: () => feeChargeEventPeriodBreakdownTableDataRetrieve(fundFamilyId,feeChargeEventId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Get the comparison data for a fee charge event
 */
export const feeChargeEventComparisonTableDataRetrieve = (
    fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeeChargeEventComparisonTableDataRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<FeeChargeEventComparison>(
      {url: `/fund-family/${fundFamilyId}/fee-charge-event/${feeChargeEventId}/period-comparison`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getFeeChargeEventComparisonTableDataRetrieveQueryKey = (fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeeChargeEventComparisonTableDataRetrieveParams,) => {
    return [`/fund-family/${fundFamilyId}/fee-charge-event/${feeChargeEventId}/period-comparison`, ...(params ? [params]: [])] as const;
    }

    
export const getFeeChargeEventComparisonTableDataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof feeChargeEventComparisonTableDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeeChargeEventComparisonTableDataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feeChargeEventComparisonTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeeChargeEventComparisonTableDataRetrieveQueryKey(fundFamilyId,feeChargeEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feeChargeEventComparisonTableDataRetrieve>>> = ({ signal }) => feeChargeEventComparisonTableDataRetrieve(fundFamilyId,feeChargeEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && feeChargeEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof feeChargeEventComparisonTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FeeChargeEventComparisonTableDataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof feeChargeEventComparisonTableDataRetrieve>>>
export type FeeChargeEventComparisonTableDataRetrieveQueryError = unknown

export const useFeeChargeEventComparisonTableDataRetrieve = <TData = Awaited<ReturnType<typeof feeChargeEventComparisonTableDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeeChargeEventComparisonTableDataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feeChargeEventComparisonTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeeChargeEventComparisonTableDataRetrieveQueryOptions(fundFamilyId,feeChargeEventId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFeeChargeEventComparisonTableDataRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof feeChargeEventComparisonTableDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeeChargeEventComparisonTableDataRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeChargeEventComparisonTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeeChargeEventComparisonTableDataRetrieveQueryKey(fundFamilyId,feeChargeEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feeChargeEventComparisonTableDataRetrieve>>> = ({ signal }) => feeChargeEventComparisonTableDataRetrieve(fundFamilyId,feeChargeEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && feeChargeEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeChargeEventComparisonTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FeeChargeEventComparisonTableDataRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof feeChargeEventComparisonTableDataRetrieve>>>
export type FeeChargeEventComparisonTableDataRetrieveSuspenseQueryError = unknown

export const useFeeChargeEventComparisonTableDataRetrieveSuspense = <TData = Awaited<ReturnType<typeof feeChargeEventComparisonTableDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeeChargeEventComparisonTableDataRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeChargeEventComparisonTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeeChargeEventComparisonTableDataRetrieveSuspenseQueryOptions(fundFamilyId,feeChargeEventId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getFeeChargeEventComparisonTableDataRetrieveLoader = (queryParamsOrFn?: (FeeChargeEventComparisonTableDataRetrieveParams | ((params: Params) => FeeChargeEventComparisonTableDataRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,feeChargeEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,feeChargeEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId && feeChargeEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getFeeChargeEventComparisonTableDataRetrieveQueryKey(fundFamilyId,feeChargeEventId, queryParams),
              queryFn: () => feeChargeEventComparisonTableDataRetrieve(fundFamilyId,feeChargeEventId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Publish a FeeChargeEvent
 */
export const feeChargeEventPublish = (
    fundFamilyId: string,
    feeChargeEventId: string,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/fund-family/${fundFamilyId}/fee-charge-event/${feeChargeEventId}/publish/`, method: 'PATCH'
    },
      options);
    }
  


export const getFeeChargeEventPublishMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof feeChargeEventPublish>>, TError,{fundFamilyId: string;feeChargeEventId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof feeChargeEventPublish>>, TError,{fundFamilyId: string;feeChargeEventId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof feeChargeEventPublish>>, {fundFamilyId: string;feeChargeEventId: string}> = (props) => {
          const {fundFamilyId,feeChargeEventId} = props ?? {};

          return  feeChargeEventPublish(fundFamilyId,feeChargeEventId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FeeChargeEventPublishMutationResult = NonNullable<Awaited<ReturnType<typeof feeChargeEventPublish>>>
    
    export type FeeChargeEventPublishMutationError = unknown

    export const useFeeChargeEventPublish = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof feeChargeEventPublish>>, TError,{fundFamilyId: string;feeChargeEventId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getFeeChargeEventPublishMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Get a FeeChargeEvent
 */
export const feeChargeEventStatsRetrieve = (
    fundFamilyId: string,
    feeChargeEventId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<FeeChargeEventStatsAPIData>(
      {url: `/fund-family/${fundFamilyId}/fee-charge-event/${feeChargeEventId}/stats`, method: 'GET', signal
    },
      options);
    }
  

export const getFeeChargeEventStatsRetrieveQueryKey = (fundFamilyId: string,
    feeChargeEventId: string,) => {
    return [`/fund-family/${fundFamilyId}/fee-charge-event/${feeChargeEventId}/stats`] as const;
    }

    
export const getFeeChargeEventStatsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof feeChargeEventStatsRetrieve>>, TError = unknown>(fundFamilyId: string,
    feeChargeEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feeChargeEventStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeeChargeEventStatsRetrieveQueryKey(fundFamilyId,feeChargeEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feeChargeEventStatsRetrieve>>> = ({ signal }) => feeChargeEventStatsRetrieve(fundFamilyId,feeChargeEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && feeChargeEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof feeChargeEventStatsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FeeChargeEventStatsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof feeChargeEventStatsRetrieve>>>
export type FeeChargeEventStatsRetrieveQueryError = unknown

export const useFeeChargeEventStatsRetrieve = <TData = Awaited<ReturnType<typeof feeChargeEventStatsRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    feeChargeEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feeChargeEventStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeeChargeEventStatsRetrieveQueryOptions(fundFamilyId,feeChargeEventId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFeeChargeEventStatsRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof feeChargeEventStatsRetrieve>>, TError = unknown>(fundFamilyId: string,
    feeChargeEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeChargeEventStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeeChargeEventStatsRetrieveQueryKey(fundFamilyId,feeChargeEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feeChargeEventStatsRetrieve>>> = ({ signal }) => feeChargeEventStatsRetrieve(fundFamilyId,feeChargeEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && feeChargeEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeChargeEventStatsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FeeChargeEventStatsRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof feeChargeEventStatsRetrieve>>>
export type FeeChargeEventStatsRetrieveSuspenseQueryError = unknown

export const useFeeChargeEventStatsRetrieveSuspense = <TData = Awaited<ReturnType<typeof feeChargeEventStatsRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    feeChargeEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeChargeEventStatsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeeChargeEventStatsRetrieveSuspenseQueryOptions(fundFamilyId,feeChargeEventId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getFeeChargeEventStatsRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,feeChargeEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,feeChargeEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && feeChargeEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getFeeChargeEventStatsRetrieveQueryKey(fundFamilyId,feeChargeEventId),
              queryFn: () => feeChargeEventStatsRetrieve(fundFamilyId,feeChargeEventId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Get table representing the breakdown of the fee true up for a particular fee period and posted event type
 */
export const feePeriodTrueUpBreakdownRetrieve = (
    fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeePeriodTrueUpBreakdownRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/fund-family/${fundFamilyId}/fee-charge-event/${feeChargeEventId}/true-up-breakdown/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getFeePeriodTrueUpBreakdownRetrieveQueryKey = (fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeePeriodTrueUpBreakdownRetrieveParams,) => {
    return [`/fund-family/${fundFamilyId}/fee-charge-event/${feeChargeEventId}/true-up-breakdown/`, ...(params ? [params]: [])] as const;
    }

    
export const getFeePeriodTrueUpBreakdownRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof feePeriodTrueUpBreakdownRetrieve>>, TError = unknown>(fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeePeriodTrueUpBreakdownRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feePeriodTrueUpBreakdownRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeePeriodTrueUpBreakdownRetrieveQueryKey(fundFamilyId,feeChargeEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feePeriodTrueUpBreakdownRetrieve>>> = ({ signal }) => feePeriodTrueUpBreakdownRetrieve(fundFamilyId,feeChargeEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && feeChargeEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof feePeriodTrueUpBreakdownRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FeePeriodTrueUpBreakdownRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof feePeriodTrueUpBreakdownRetrieve>>>
export type FeePeriodTrueUpBreakdownRetrieveQueryError = unknown

export const useFeePeriodTrueUpBreakdownRetrieve = <TData = Awaited<ReturnType<typeof feePeriodTrueUpBreakdownRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeePeriodTrueUpBreakdownRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feePeriodTrueUpBreakdownRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeePeriodTrueUpBreakdownRetrieveQueryOptions(fundFamilyId,feeChargeEventId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFeePeriodTrueUpBreakdownRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof feePeriodTrueUpBreakdownRetrieve>>, TError = unknown>(fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeePeriodTrueUpBreakdownRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feePeriodTrueUpBreakdownRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeePeriodTrueUpBreakdownRetrieveQueryKey(fundFamilyId,feeChargeEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feePeriodTrueUpBreakdownRetrieve>>> = ({ signal }) => feePeriodTrueUpBreakdownRetrieve(fundFamilyId,feeChargeEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && feeChargeEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof feePeriodTrueUpBreakdownRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FeePeriodTrueUpBreakdownRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof feePeriodTrueUpBreakdownRetrieve>>>
export type FeePeriodTrueUpBreakdownRetrieveSuspenseQueryError = unknown

export const useFeePeriodTrueUpBreakdownRetrieveSuspense = <TData = Awaited<ReturnType<typeof feePeriodTrueUpBreakdownRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeePeriodTrueUpBreakdownRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feePeriodTrueUpBreakdownRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeePeriodTrueUpBreakdownRetrieveSuspenseQueryOptions(fundFamilyId,feeChargeEventId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getFeePeriodTrueUpBreakdownRetrieveLoader = (queryParamsOrFn?: (FeePeriodTrueUpBreakdownRetrieveParams | ((params: Params) => FeePeriodTrueUpBreakdownRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,feeChargeEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,feeChargeEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId && feeChargeEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getFeePeriodTrueUpBreakdownRetrieveQueryKey(fundFamilyId,feeChargeEventId, queryParams),
              queryFn: () => feePeriodTrueUpBreakdownRetrieve(fundFamilyId,feeChargeEventId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Get tables representing the breakdown of the management fee catch up and associated equalization of offsets for a particular fee period
 */
export const feePeriodOffsetsTrueUpBreakdownRetrieve = (
    fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeePeriodOffsetsTrueUpBreakdownRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/fund-family/${fundFamilyId}/fee-charge-event/${feeChargeEventId}/true-up-breakdown/offsets`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getFeePeriodOffsetsTrueUpBreakdownRetrieveQueryKey = (fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeePeriodOffsetsTrueUpBreakdownRetrieveParams,) => {
    return [`/fund-family/${fundFamilyId}/fee-charge-event/${feeChargeEventId}/true-up-breakdown/offsets`, ...(params ? [params]: [])] as const;
    }

    
export const getFeePeriodOffsetsTrueUpBreakdownRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof feePeriodOffsetsTrueUpBreakdownRetrieve>>, TError = unknown>(fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeePeriodOffsetsTrueUpBreakdownRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feePeriodOffsetsTrueUpBreakdownRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeePeriodOffsetsTrueUpBreakdownRetrieveQueryKey(fundFamilyId,feeChargeEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feePeriodOffsetsTrueUpBreakdownRetrieve>>> = ({ signal }) => feePeriodOffsetsTrueUpBreakdownRetrieve(fundFamilyId,feeChargeEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && feeChargeEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof feePeriodOffsetsTrueUpBreakdownRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FeePeriodOffsetsTrueUpBreakdownRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof feePeriodOffsetsTrueUpBreakdownRetrieve>>>
export type FeePeriodOffsetsTrueUpBreakdownRetrieveQueryError = unknown

export const useFeePeriodOffsetsTrueUpBreakdownRetrieve = <TData = Awaited<ReturnType<typeof feePeriodOffsetsTrueUpBreakdownRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeePeriodOffsetsTrueUpBreakdownRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feePeriodOffsetsTrueUpBreakdownRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeePeriodOffsetsTrueUpBreakdownRetrieveQueryOptions(fundFamilyId,feeChargeEventId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFeePeriodOffsetsTrueUpBreakdownRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof feePeriodOffsetsTrueUpBreakdownRetrieve>>, TError = unknown>(fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeePeriodOffsetsTrueUpBreakdownRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feePeriodOffsetsTrueUpBreakdownRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeePeriodOffsetsTrueUpBreakdownRetrieveQueryKey(fundFamilyId,feeChargeEventId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feePeriodOffsetsTrueUpBreakdownRetrieve>>> = ({ signal }) => feePeriodOffsetsTrueUpBreakdownRetrieve(fundFamilyId,feeChargeEventId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && feeChargeEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof feePeriodOffsetsTrueUpBreakdownRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FeePeriodOffsetsTrueUpBreakdownRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof feePeriodOffsetsTrueUpBreakdownRetrieve>>>
export type FeePeriodOffsetsTrueUpBreakdownRetrieveSuspenseQueryError = unknown

export const useFeePeriodOffsetsTrueUpBreakdownRetrieveSuspense = <TData = Awaited<ReturnType<typeof feePeriodOffsetsTrueUpBreakdownRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    feeChargeEventId: string,
    params?: FeePeriodOffsetsTrueUpBreakdownRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feePeriodOffsetsTrueUpBreakdownRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeePeriodOffsetsTrueUpBreakdownRetrieveSuspenseQueryOptions(fundFamilyId,feeChargeEventId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getFeePeriodOffsetsTrueUpBreakdownRetrieveLoader = (queryParamsOrFn?: (FeePeriodOffsetsTrueUpBreakdownRetrieveParams | ((params: Params) => FeePeriodOffsetsTrueUpBreakdownRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,feeChargeEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,feeChargeEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId && feeChargeEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getFeePeriodOffsetsTrueUpBreakdownRetrieveQueryKey(fundFamilyId,feeChargeEventId, queryParams),
              queryFn: () => feePeriodOffsetsTrueUpBreakdownRetrieve(fundFamilyId,feeChargeEventId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Get tables representing the breakdown of a fee true up event
 */
export const feePeriodTrueUpSummaryTablesRetrieve = (
    fundFamilyId: string,
    feeChargeEventId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<FeeTrueUpSummaryTablesData>(
      {url: `/fund-family/${fundFamilyId}/fee-charge-event/${feeChargeEventId}/true-up-summary-tables/`, method: 'GET', signal
    },
      options);
    }
  

export const getFeePeriodTrueUpSummaryTablesRetrieveQueryKey = (fundFamilyId: string,
    feeChargeEventId: string,) => {
    return [`/fund-family/${fundFamilyId}/fee-charge-event/${feeChargeEventId}/true-up-summary-tables/`] as const;
    }

    
export const getFeePeriodTrueUpSummaryTablesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof feePeriodTrueUpSummaryTablesRetrieve>>, TError = unknown>(fundFamilyId: string,
    feeChargeEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feePeriodTrueUpSummaryTablesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeePeriodTrueUpSummaryTablesRetrieveQueryKey(fundFamilyId,feeChargeEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feePeriodTrueUpSummaryTablesRetrieve>>> = ({ signal }) => feePeriodTrueUpSummaryTablesRetrieve(fundFamilyId,feeChargeEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && feeChargeEventId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof feePeriodTrueUpSummaryTablesRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FeePeriodTrueUpSummaryTablesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof feePeriodTrueUpSummaryTablesRetrieve>>>
export type FeePeriodTrueUpSummaryTablesRetrieveQueryError = unknown

export const useFeePeriodTrueUpSummaryTablesRetrieve = <TData = Awaited<ReturnType<typeof feePeriodTrueUpSummaryTablesRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    feeChargeEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feePeriodTrueUpSummaryTablesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeePeriodTrueUpSummaryTablesRetrieveQueryOptions(fundFamilyId,feeChargeEventId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFeePeriodTrueUpSummaryTablesRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof feePeriodTrueUpSummaryTablesRetrieve>>, TError = unknown>(fundFamilyId: string,
    feeChargeEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feePeriodTrueUpSummaryTablesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeePeriodTrueUpSummaryTablesRetrieveQueryKey(fundFamilyId,feeChargeEventId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feePeriodTrueUpSummaryTablesRetrieve>>> = ({ signal }) => feePeriodTrueUpSummaryTablesRetrieve(fundFamilyId,feeChargeEventId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && feeChargeEventId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof feePeriodTrueUpSummaryTablesRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type FeePeriodTrueUpSummaryTablesRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof feePeriodTrueUpSummaryTablesRetrieve>>>
export type FeePeriodTrueUpSummaryTablesRetrieveSuspenseQueryError = unknown

export const useFeePeriodTrueUpSummaryTablesRetrieveSuspense = <TData = Awaited<ReturnType<typeof feePeriodTrueUpSummaryTablesRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    feeChargeEventId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feePeriodTrueUpSummaryTablesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeePeriodTrueUpSummaryTablesRetrieveSuspenseQueryOptions(fundFamilyId,feeChargeEventId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getFeePeriodTrueUpSummaryTablesRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,feeChargeEventId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,feeChargeEventId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && feeChargeEventId) {
            return appQueryClient.prefetchQuery({
              queryKey: getFeePeriodTrueUpSummaryTablesRetrieveQueryKey(fundFamilyId,feeChargeEventId),
              queryFn: () => feePeriodTrueUpSummaryTablesRetrieve(fundFamilyId,feeChargeEventId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Get a list of fee charge events to select from
 */
export const feeChargeEventsSelectList = (
    fundFamilyId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericSelectDataList>(
      {url: `/fund-family/${fundFamilyId}/fee-charge-event/list`, method: 'GET', signal
    },
      options);
    }
  

export const getFeeChargeEventsSelectListQueryKey = (fundFamilyId: string,) => {
    return [`/fund-family/${fundFamilyId}/fee-charge-event/list`] as const;
    }

    
export const getFeeChargeEventsSelectListQueryOptions = <TData = Awaited<ReturnType<typeof feeChargeEventsSelectList>>, TError = unknown>(fundFamilyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feeChargeEventsSelectList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeeChargeEventsSelectListQueryKey(fundFamilyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feeChargeEventsSelectList>>> = ({ signal }) => feeChargeEventsSelectList(fundFamilyId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof feeChargeEventsSelectList>>, TError, TData> & { queryKey: QueryKey }
}

export type FeeChargeEventsSelectListQueryResult = NonNullable<Awaited<ReturnType<typeof feeChargeEventsSelectList>>>
export type FeeChargeEventsSelectListQueryError = unknown

export const useFeeChargeEventsSelectList = <TData = Awaited<ReturnType<typeof feeChargeEventsSelectList>>, TError = unknown>(
 fundFamilyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feeChargeEventsSelectList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeeChargeEventsSelectListQueryOptions(fundFamilyId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFeeChargeEventsSelectListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof feeChargeEventsSelectList>>, TError = unknown>(fundFamilyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeChargeEventsSelectList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeeChargeEventsSelectListQueryKey(fundFamilyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feeChargeEventsSelectList>>> = ({ signal }) => feeChargeEventsSelectList(fundFamilyId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeChargeEventsSelectList>>, TError, TData> & { queryKey: QueryKey }
}

export type FeeChargeEventsSelectListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof feeChargeEventsSelectList>>>
export type FeeChargeEventsSelectListSuspenseQueryError = unknown

export const useFeeChargeEventsSelectListSuspense = <TData = Awaited<ReturnType<typeof feeChargeEventsSelectList>>, TError = unknown>(
 fundFamilyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeChargeEventsSelectList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeeChargeEventsSelectListSuspenseQueryOptions(fundFamilyId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getFeeChargeEventsSelectListLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId) {
            return appQueryClient.prefetchQuery({
              queryKey: getFeeChargeEventsSelectListQueryKey(fundFamilyId),
              queryFn: () => feeChargeEventsSelectList(fundFamilyId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Get a list of point in time transaction codes that affect a given fee charge event.
 */
export const feeChargeEventPointInTimeTransactionCodesList = (
    fundFamilyId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<TransactionCodeConfigDataList>(
      {url: `/fund-family/${fundFamilyId}/fee-charge-event/point-in-time-transaction-codes`, method: 'GET', signal
    },
      options);
    }
  

export const getFeeChargeEventPointInTimeTransactionCodesListQueryKey = (fundFamilyId: string,) => {
    return [`/fund-family/${fundFamilyId}/fee-charge-event/point-in-time-transaction-codes`] as const;
    }

    
export const getFeeChargeEventPointInTimeTransactionCodesListQueryOptions = <TData = Awaited<ReturnType<typeof feeChargeEventPointInTimeTransactionCodesList>>, TError = unknown>(fundFamilyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feeChargeEventPointInTimeTransactionCodesList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeeChargeEventPointInTimeTransactionCodesListQueryKey(fundFamilyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feeChargeEventPointInTimeTransactionCodesList>>> = ({ signal }) => feeChargeEventPointInTimeTransactionCodesList(fundFamilyId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof feeChargeEventPointInTimeTransactionCodesList>>, TError, TData> & { queryKey: QueryKey }
}

export type FeeChargeEventPointInTimeTransactionCodesListQueryResult = NonNullable<Awaited<ReturnType<typeof feeChargeEventPointInTimeTransactionCodesList>>>
export type FeeChargeEventPointInTimeTransactionCodesListQueryError = unknown

export const useFeeChargeEventPointInTimeTransactionCodesList = <TData = Awaited<ReturnType<typeof feeChargeEventPointInTimeTransactionCodesList>>, TError = unknown>(
 fundFamilyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof feeChargeEventPointInTimeTransactionCodesList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeeChargeEventPointInTimeTransactionCodesListQueryOptions(fundFamilyId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getFeeChargeEventPointInTimeTransactionCodesListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof feeChargeEventPointInTimeTransactionCodesList>>, TError = unknown>(fundFamilyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeChargeEventPointInTimeTransactionCodesList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFeeChargeEventPointInTimeTransactionCodesListQueryKey(fundFamilyId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof feeChargeEventPointInTimeTransactionCodesList>>> = ({ signal }) => feeChargeEventPointInTimeTransactionCodesList(fundFamilyId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeChargeEventPointInTimeTransactionCodesList>>, TError, TData> & { queryKey: QueryKey }
}

export type FeeChargeEventPointInTimeTransactionCodesListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof feeChargeEventPointInTimeTransactionCodesList>>>
export type FeeChargeEventPointInTimeTransactionCodesListSuspenseQueryError = unknown

export const useFeeChargeEventPointInTimeTransactionCodesListSuspense = <TData = Awaited<ReturnType<typeof feeChargeEventPointInTimeTransactionCodesList>>, TError = unknown>(
 fundFamilyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof feeChargeEventPointInTimeTransactionCodesList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getFeeChargeEventPointInTimeTransactionCodesListSuspenseQueryOptions(fundFamilyId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getFeeChargeEventPointInTimeTransactionCodesListLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId) {
            return appQueryClient.prefetchQuery({
              queryKey: getFeeChargeEventPointInTimeTransactionCodesListQueryKey(fundFamilyId),
              queryFn: () => feeChargeEventPointInTimeTransactionCodesList(fundFamilyId),
            }).then(() => null);
          }
          return null;
        });
      